import React from 'react';
import dayjs from 'dayjs';
import { setColumnSort } from '../../../libs/utils';
//----------------------------------------------------------------------------------------------------
// images
// import ico_more from '../../../assets/images/ico_more.png';
//----------------------------------------------------------------------------------------------------
const NoticeColumns = (props) => {
  const {
    sorts,
    setSorts,
    loading,
    setLoading,
    OnCellClick,
    OnDeleted,
    OnCopy,
    ...rests
  } = props;

  return [
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'title'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'공지사항 제목'}
          </div>
        );
      },
      width: 308,
      dataIndex: 'title',
      key: 'title',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ ...obj });
          }}
        >
          {value}
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'content'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'공지사항 내용'}
          </div>
        );
      },
      width: 580,
      dataIndex: 'content',
      key: 'content',
      sorter: true,
      render: (value, obj) => {
        const length = 80;
        let content = String(value).trim();
        if (content.length > length) {
          content =
            content.substring(0, length - 2) +
            '<br/>&nbsp; &nbsp; &nbsp; &nbsp;<p>...</p>';
        }

        return (
          <div
            style={{ ...styles.col_text }}
            onClick={(e) => {
              OnCellClick({ ...obj });
            }}
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        );
      },
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'announceDate'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'공지일'}
          </div>
        );
      },
      width: 112,
      dataIndex: 'announceDate',
      key: 'announceDate',
      sorter: true,
      render: (value, obj) => {
        return (
          <div
            style={{ ...styles.col_text }}
            onClick={(e) => {
              OnCellClick({ ...obj });
            }}
          >
            {(value && dayjs(value).format('YYYY.MM.DD')) || '-'}
          </div>
        );
      },
    },
    /* ---------- */
    {
      title: (
        <div
          style={{
            display: 'flex',
            width: '3rem',
            flexDirection: 'column',
            justifyContetn: 'center',
            alignItems: 'center',
          }}
        >
          {`복사`}
        </div>
      ),
      width: 52,
      // height: 48,
      render: (value, obj) => {
        return (
          <img
            width={22}
            height={22}
            src={require('../../../assets/images/ico_copy.png')}
            onClick={(e) => {
              OnCopy({ id: obj.id, content: obj.content });
            }}
          />
        );
      },
    },
    /* ---------- */
    {
      title: (
        <div
          style={{
            display: 'flex',
            width: '3rem',
            flexDirection: 'column',
            justifyContetn: 'center',
            alignItems: 'center',
          }}
        >
          {`삭제`}
        </div>
      ),
      width: 52,
      // height: 48,
      render: (value, obj) => {
        // const uuid = obj.uuid;
        // const adminName = obj.name;
        // const centerName = obj.name;
        return (
          <img
            width={22}
            height={22}
            src={require('../../../assets/images/ico_trash.png')}
            onClick={(e) => {
              OnDeleted({ id: obj.id });
            }}
          />
        );
      },
      fixed: 'right',
    },
  ];
};

//----------------------------------------------------------------------------------------------------
const styles = {
  col_headers: {
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  col1: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  col1_text: {
    display: 'flex',
    marginLeft: '1rem',
    wordWrap: true,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
  },
  col_text: {
    display: 'flex',
    marginLeft: '1rem',
    wordWrap: true,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
  },
  col_plan: {
    display: 'flex',
    width: '9.6rem',
    height: '2.4rem',
    wordWrap: true,
    gap: '1rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 10px',
    background: 'rgba(40, 199, 111, 0.16)',
    borderRadius: 4,
    color: '#28C76F',
  },
};

export default NoticeColumns;
